// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientUpsearchModel } from './patientUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SavePatientRequestModel {
    'patientUpsearchModel': PatientUpsearchModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SavePatientRequestModel>> = [
        {
            "name":     "patientUpsearchModel",
            "baseName": "patientUpsearchModel",
            "type":     "PatientUpsearchModel"
        },
    ];

    static getAttributeTypeMap() {
        return SavePatientRequestModel.attributeTypeMap;
    }
}
